import {AvatarPart, uid} from "../common";

export default new AvatarPart({
	defs: [

	],
	render () {
		return ``;
	},
	attrs: {

	},
});



// WEBPACK FOOTER //
// ./src/accessories/blank.js